import React from "react";
import {Box, Button, Grid, Modal, Typography} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {Elements} from "@stripe/react-stripe-js";
import {loadStripe} from "@stripe/stripe-js";
import SaveNewCard from "./SaveNewCardModel";

import featured from "../../../assets/images/featured.svg";
import featuredDefault from "../../../assets/images/featuredDefault.svg";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 480,
  color: "rgba(255, 255, 255, 0.6)",
  bgcolor: "#0F0F0F",
  border: "1px solid rgba(255, 255, 255, 0.12)",
  boxShadow: "0px 20px 24px -4px rgba(16, 24, 40, 0.08), 0px 8px 8px -4px rgba(16, 24, 40, 0.03)",
  borderRadius: "12px",
  "&:focus-visible": {
    outline: "none",
  },
  "@media(max-width: 599px)": {
    width: "90%",
  },
};

const stripe = loadStripe(process.env.REACT_APP_STRIPE_SECRET_KEY);

const PaymentModal = ({handleClose, open, setOpen, setDefaultSource, cards, defaultCardId, setShowAlert}) => {
  return (
    <Modal open={!!open} onClose={handleClose} className="addPaymentModal backdrop">
      <Box sx={style}>
        <Box p={{sm: 3, xs: 2}}>
          <Box display={"flex"} alignItems={"flex-start"} justifyContent={"space-between"} mb={{sm: 3, xs: 2}}>
            <Box className="modalHeader" display={"flex"} alignItems={"flex-start"}>
              <img src={open === "default" ? featuredDefault : featured} alt="featured" />
              <Box ml={2}>
                <Typography variant="h4">
                  {open === "create" ? "Add new payment method" : open === "default" ? "" : "Update payment method"}
                </Typography>
                <Typography variant="h6">
                  {open === "create"
                    ? "This form is secure and encrypted by Stripe."
                    : open === "default"
                    ? ""
                    : "This form is secure and encrypted by Stripe."}
                </Typography>
              </Box>
            </Box>
            <Box className="closeModal" onClick={() => setOpen(false)}>
              <CloseIcon />
            </Box>
          </Box>
          {open === "default" ? (
            <Box>
              <Typography variant="h4" mb={1}>
                Update default payment method
              </Typography>
              <Typography variant="h6">
                Do you wish to set Mastercard **{cards.find((card) => card.id === defaultCardId)?.card?.last4} as your
                default payment method? This will take place immediately and you will not be charged until your next
                billing cycle.
              </Typography>
              <Grid container mt={3} spacing={2}>
                <Grid item xs={6}>
                  <Button fullWidth style={{color: open === "default" && "#ffffffde"}} onClick={() => setOpen(false)}>
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button fullWidth className="btnSave" onClick={() => setDefaultSource()}>
                    Confirm
                  </Button>
                </Grid>
              </Grid>
            </Box>
          ) : (
            <Elements stripe={stripe}>
              <SaveNewCard open={open} setOpen={setOpen} cards={cards} setShowAlert={setShowAlert} />
            </Elements>
          )}
        </Box>
      </Box>
    </Modal>
  );
};

export default PaymentModal;
